import requests from '../requests'

export default {
  list () {
    return requests.get('meta/manufacturers')
  },
  get (id) {
    return requests.get(`meta/manufacturers/${id}`)
  },
  create (obj) {
    return requests.post('meta/manufacturers', obj)
  },
  update (obj) {
    return requests.put(`meta/manufacturers/${obj.id}`, obj)
  },
  delete (obj) {
    return requests.delete(`meta/manufacturers/${obj.id}`)
  }
}
